import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import PageLoader from "./PageLoader";

interface PublicRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

function PublicRoute({ children, redirectTo }: PublicRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <PageLoader />;
  }

  // Redirect based on onboarding status if already authenticated
  if (isAuthenticated) {
    // If custom redirectTo is specified, use it
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }

    const destination = "/chat";

    return <Navigate to={destination} replace />;
  }

  // User is not authenticated, render the public content
  return <>{children}</>;
}

export default PublicRoute;
